export const EVENTS = {
	// Phaser -> React
	GAME_STARTED: 'tracingGameStarted',
	GAME_FINISHED: 'tracingGameFinished',
	FAILURE: 'tracingGameFailure',
	INACTIVE: 'tracingGameInactive',
	SKIP: 'tracingGameSkip',
	SCENE_READY: 'tracingGameSceneReady',
	VICTORY: 'tracingGameVictory',

	// React -> Phaser
	LOAD_GAME: 'tracingGameLoadGame',
	SET_AUDIO_ON: 'tracingGameSetAudioOn',
	RETRY_GAME: 'tracingGameRetryGame',
} as const;
